const initState = {
  otpApps: [],
  otpAppSms: {},
  otpAppWa: {},
  customer: {},
  loading: false,
  error: false,
  loading_OTP: false,
  error_OTP: false,
}

const reducer = (state = initState, action) => {
  switch (action.type) {
    case 'SET_OTP_APPS':
      return {...state, otpApps: action.payload}
    case 'SET_OTP_APP_SMS': 
      return {...state, otpAppSms: action.payload}
    case 'SET_OTP_APP_WA': 
      return {...state, otpAppWa: action.payload}
    case 'SET_CUSTOMER_APP': 
      return {...state, customer: action.payload}
    case 'SET_LOADING': 
      return {...state, loading: action.payload}
    case 'SET_ERROR':
      return {...state, error: action.payload}
    case 'SET_LOADING_OTP': 
      return {...state, loading_OTP: action.payload}
    case 'SET_ERROR_OTP':
      return {...state, error_OTP: action.payload}
    default: 
      return state
  }
}

export default reducer